import { useEventCallback, useUpdateEffect } from '@cian/react-utils';

import { type FC, useState } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { AdFoxBanner } from '../AdfoxBanner';
import { AdfoxContextProvider, type AdfoxContextProviderProps } from '../AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'bvkoa', p2: 'y' };

type AdfoxParallaxBannerProps = {
  position: number;
  serverData: AdfoxContextProviderProps['serverData'];
  isNarrow: boolean;
};

export const AdfoxParallaxBanner: FC<AdfoxParallaxBannerProps> = memoWithDisplayName(
  ({ position, serverData, isNarrow }) => {
    const [isHtmlBanner, setIsHtmlBanner] = useState<boolean>(false);
    const [bannerKey, setBannerKey] = useState<string>();

    const trackBannerAsHtml = useEventCallback(() => {
      setIsHtmlBanner(true);
    });

    const bannerDeviceType = isNarrow ? 'phone' : 'desktop';

    /**
     * @description
     * Обновляем ключ html-баннеров при изменении viewMode.
     * Это делаем, поскольку html-баннеры не умеют в адаптив и их нужно вручную перерисовывать
     */
    useUpdateEffect(() => {
      if (isHtmlBanner) {
        setBannerKey(`adfox-html-${bannerDeviceType}-banner-${position}`);
      }
    }, [bannerDeviceType]);

    return (
      <AdfoxContextProvider
        bannerDeviceType={isNarrow ? 'phone' : 'desktop'}
        pParams={P_PARAMS}
        postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
        serverData={serverData}
        size={SIZE}
        trackBannerAsHtml={trackBannerAsHtml}
      >
        <AdFoxBanner key={bannerKey} position={position} />
      </AdfoxContextProvider>
    );
  },
  'AdfoxParallaxBanner',
);
